import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, Box, CardContent, CardHeader, IconButton, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import StyledCard from './StyledCard';
import BackgroundPattern from '@public/assets/images/event-card-bg.png';
import useFullHeightCardStyles from './useFullHeightCardStyles';
import { FilterAltOutlined } from '@mui/icons-material';
const FullHeightCard = ({ variant = 'light', icon, heading, info, children, infoTooltip, bgPattern = false, filter = true, bgPosition, sx, cardContentContainersx, actionContent, disableBackground, disableBorders, disableShadow, headerTypographyVariant, headerTypographyColor, cardHeaderPadding, height }) => {
    const theme = useTheme();
    const styles = useFullHeightCardStyles(variant, height);
    const isMobile = useMediaQuery(theme.breakpoints.down(1280));
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const handleTooltipClick = () => {
        if (isMobile && infoTooltip) {
            setTooltipOpen((prev) => !prev);
            setTimeout(() => setTooltipOpen(false), 2000);
        }
    };
    const getBgPatternStyles = (position) => ({
        backgroundImage: `url(${BackgroundPattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: position,
        backgroundSize: 'cover'
    });
    return (_jsxs(StyledCard, { customVariant: variant, disableBackground: disableBackground, disableBorders: disableBorders, disableShadow: disableShadow, sx: [
            {
                height: '100%'
            },
            // ...(bgPattern ? [getBgPatternStyles(bgPosition || 'bottom')] : []),
            ...(Array.isArray(sx) ? sx : [sx || {}])
        ], children: [_jsx(CardHeader, { style: { padding: cardHeaderPadding || '17px 20px' }, avatar: icon && icon, title: _jsx(Typography, { variant: headerTypographyVariant || 'h6', color: headerTypographyColor ||
                        (variant === 'light' ? theme.palette.grey[900] : theme.palette.common.white), fontWeight: 500, children: heading }), action: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [filter && (_jsx(Box, { className: 'filter-menu-container', children: _jsx(IconButton, { size: 'Xs', sx: {
                                    color: variant === 'light' ? theme.palette.action.active : theme.palette.grey[500],
                                    background: variant === 'blue'
                                        ? alpha(theme.palette.grey[800], 0.4)
                                        : theme.palette.background.neutral,
                                    backdropFilter: 'blur(40px)'
                                }, children: _jsx(FilterAltOutlined, { sx: { aspectRatio: '1 / 1', width: '13.5px' } }) }) })), info &&
                            (infoTooltip ? (_jsx(Tooltip, { title: infoTooltip, arrow: true, open: isMobile ? tooltipOpen : undefined, disableHoverListener: isMobile, disableFocusListener: isMobile, disableTouchListener: isMobile, children: _jsx(IconButton, { sx: { border: 'none' }, onClick: handleTooltipClick, children: info }) })) : (_jsx(IconButton, { sx: { border: 'none' }, children: info }))), actionContent] }) }), _jsx(CardContent, { sx: [
                    {
                        ...styles.cardContentContainer
                    },
                    ...(Array.isArray(cardContentContainersx)
                        ? cardContentContainersx
                        : [cardContentContainersx || {}])
                ], children: children })] }));
};
export default FullHeightCard;
